import { Box, Table, Tbody, Tr, Td, Link, Text, Heading, Flex, Input, Button, Icon, Grid, GridItem, Image, useMediaQuery, Select } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { MdOutlineViewList, MdOutlineViewModule } from "react-icons/md";
import dayjs from "dayjs";
import { useQuery } from "react-query";
import Section from "../../../Component/Layout/Section";
import PageTitle from "../../../Component/Page/PageTitle";
import { getBoardInfo, getBoardList, getWPpostList, getWPpostTypeInfo } from "../../../service";
import { PagiNationSection } from "./style";
import { boardGrorups } from "./meta";
import { theme } from "../../../assets/style/theme";
import { boardLabels, defaultUserInfo, testUserInfo } from "../meta";
import { contentFilter } from "../../../util";

declare var __AUTH__: any;

type Props = {
	params: any;
};

function BoardList({ params }: Props) {
	let limit = 12;
	let offset = params.pageNum !== undefined ? (Number(params.pageNum) - 1) * limit : 0;

	const requestList = params.reqmode === "wp" ? getWPpostList : getBoardList;

	const { isLoading: isLoadingList, error: listError, data: list } = useQuery("BoardList", () => requestList(params.board_id, limit, offset, params?.keyword === undefined ? "" : params.keyword, params?.category === undefined ? "" : params.category));

	const requestInfo = params.reqmode === "wp" ? getWPpostTypeInfo : getBoardInfo;

	const { isLoading: isLoadinBoardInfo, error: boardInfoError, data: boardInfo } = useQuery("BoardInfo", () => requestInfo(params.board_id));

	const [viewMode, setViewMode] = useState("list" as "list" | "table");
	const [userInfo, setUserInfo] = useState(defaultUserInfo);

	const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
	const [keyword, setKeyword] = useState('');
	const [category, setCategory] = useState('');

	useEffect(() => {
		if (boardInfo && boardInfo?.permission_read !== 'all') {
      window.location.href = '/';
    }    
		if (boardInfo !== undefined) {
			setViewMode(boardInfo.listMode);
		}
	}, [boardInfo]);

	useEffect(() => {
		if (process.env.NODE_ENV === "development") {
			setUserInfo(testUserInfo);
		} else {
			setUserInfo(__AUTH__ ? __AUTH__ : defaultUserInfo);
		}

		setKeyword(params.keyword === undefined ? '' : params.keyword);
		setCategory(params.category === undefined ? '' : params.category);
		
	}, []);

	const tableStyle = {
		borderTopWidth: "3px",
		borderStyle: "solid",
		borderTopColor: "b.dgr",
	};

	const tdStyle = {
		borderBottomWidth: "1px",
		borderStyle: "solid",
		borderBottomColor: "b.g",
		pt: isMobile ? "4" : "8",
		pb: isMobile ? "4" : "8",
		pl: isMobile ? "2" : "5",
		pr: isMobile ? "2" : "5",
		fontWeight: "800",
	};

	const pageClick = (e: any) => {
		const newHref = window.location.href.includes("pageNum=") ? window.location.href.split("pageNum=")[0] + "pageNum=" + (e.selected + 1) : window.location.href + "&pageNum=" + (e.selected + 1);
		window.location.href = newHref;
	};

	const onKeywordInputPress = (e: any) => {
		if (e.key === "Enter") {
			let newHref = window.location.href.includes("keyword=") ? `${window.location.href.split("keyword=")[0]}keyword=${e.target.value}` : `${window.location.href}&keyword=${e.target.value}`;

			if (category !== '') {
				newHref = newHref.includes("category=") ? `${newHref.split("category=")[0]}category=${category}` : `${newHref}&category=${category}`;
			}

			window.location.href = newHref;
		}
	};

	const groups = boardGrorups.filter((item: any) => item.ids.includes(params.board_id));

	const isEnglish = window.__LANG__ === "en";

	return (
		<>
			{!isLoadinBoardInfo && !boardInfoError && (
				<>
					<PageTitle type="big" bgPath="board/news.jpg" title={boardInfo.parent_title} description={boardInfo.description} />

					{groups.length > 0 && (
						<Box pt="9" pb="0" textAlign="center">
							{groups[0].list.map((item: any, index: number) => (
								<Button
									key={index}
									as="a"
									href={`/board?board_id=${item.boardId}`}
									size="lg"
									fontSize="md"
									colorScheme={item.boardId === params.board_id ? "dgr" : "g"}
									variant={item.boardId === params.board_id ? "solid" : "outline"}
									ml={2}
									mr={2}
									mb={2}
								>
									{item.title}
								</Button>
							))}
						</Box>
					)}

					<Section pt={isMobile ? 40 : 100} pb={isMobile ? 24 : 48}>
						<Flex justifyContent="space-between" alignItems="center">
							<Flex alignItems="center">
								<Heading size={isMobile ? "3xl" : "5xl"} color="b.dgr">
									{boardInfo.board_name}
								</Heading>
								<Box pl={3} pr={3} mt={isMobile ? 0 : 1}>
									<button onClick={() => setViewMode("list")}>
										<Icon as={MdOutlineViewList} w={8} h={8} color={viewMode === "list" ? "b.dgr" : "b.lg"} />
									</button>
									<button onClick={() => setViewMode("table")}>
										<Icon as={MdOutlineViewModule} w={8} h={8} color={viewMode === "table" ? "b.dgr" : "b.lg"} />
									</button>
								</Box>
							</Flex>
							<Flex>
								{
									boardInfo.category1_list.length !== 0 && (
										<Box mr={3}>
											<Select size="lg" placeholder={boardLabels('selectAll', Number(params.board_id))} onChange={(e) => setCategory(e.target.value)} value={category}>
												{
													boardInfo.category1_list.split(',').map((item:any) => (
														<option key={item} value={item}>{item}</option>
													))
												}
											</Select>
										</Box>
									)
								}
								{!isMobile && (
									<Box>
										<Input type="search" w={300} size="lg" borderRadius={100} borderColor="b.lg" variant="outline" placeholder={boardLabels('searchPlaceholder', Number(params.board_id))} value={keyword} onChange={(e:any) => setKeyword(e.target.value)} onKeyUp={onKeywordInputPress} />
									</Box>
								)}
							</Flex>
						</Flex>
					</Section>
				</>
			)}

			{!isLoadingList && !listError && list.items.length !== 0 && (
				<>
					<Section pb={1} pt={1}>
						{viewMode === "list" && (
							<Table variant="simple" size="lg" {...tableStyle}>
								<Tbody>
									{list.items.map((item: any, index: number) => (
										<Tr key={index}>
											{!isMobile && (
												<Td fontSize="2xl" {...tdStyle}>
													{item.uid}
												</Td>
											)}
											<Td w={isMobile ? "100%" : "70%"} {...tdStyle}>
												<Text fontSize={isMobile ? "xl" : "2xl"} fontWeight="800" w="99%" noOfLines={1}>
													<Link href={`${isEnglish ? '/en' : ''}/board?mode=view&board_id=${params.board_id}&post_id=${item.post_id}${params.reqmode === "wp" ? "&reqmode=wp" : ""}`} dangerouslySetInnerHTML={{ __html: contentFilter(item.title) }}></Link>
												</Text>
											</Td>
											{!isMobile && (
												<Td fontSize="2xl" color="b.lg" whiteSpace="nowrap" {...tdStyle} textAlign="right">
													{dayjs(item.date).format("YYYY. MM. DD")}
												</Td>
											)}
										</Tr>
									))}
								</Tbody>
							</Table>
						)}
						{viewMode === "table" && (
							<Grid templateColumns={isMobile ? "repeat(1, 1fr)" : "repeat(4, 1fr)"} gap={6}>
								{list.items.map((item: any, index: number) => (
									<GridItem key={index} w="100%" borderWidth="1px" borderColor="b.lg" borderStyle="solid">
										<Link href={`${isEnglish ? '/en' : ''}/board?mode=view&board_id=${params.board_id}&post_id=${item.post_id}${params.reqmode === "wp" ? "&reqmode=wp" : ""}`}>
											{item.thumbnail_file.length !== 0 ? (
												<Image src={item.thumbnail_file.includes("http") ? item.thumbnail_file : `https://koreashe.org${item.thumbnail_file}`} objectFit="cover" w="100%" h={200} />
											) : (
												<Box w="100%" h={200} bg="b.gr"></Box>
											)}
										</Link>

										<Box p={4}>
											<Heading size={isMobile ? "xl" : "lg"} lineHeight={1.4}>
												<Link href={`${isEnglish ? '/en' : ''}/board?mode=view&board_id=${params.board_id}&post_id=${item.uid}`} dangerouslySetInnerHTML={{ __html: contentFilter(item.title) }}></Link>
											</Heading>
										</Box>
									</GridItem>
								))}
							</Grid>
						)}
					</Section>
				</>
			)}
      {!isLoadingList && !listError && list.items.length === 0 && (
				<Box textAlign="center" pt={100} pb={100}>
					<Heading size="2xl" color="b.gr">
						{boardLabels('empty', Number(params.board_id))}
					</Heading>
				</Box>
			)}
			{userInfo.isLoggedIn && !isLoadinBoardInfo && boardInfo.permission_write === "author" && (
				<Section pb={!isLoadingList && !listError && list.items.length === 0 ? 80 : 1} pt={40}>
					<Box textAlign="right">
						<Link href={`${isEnglish ? '/en' : ''}/board?mode=write&board_id=${params.board_id}`}>
							<Button colorScheme="dgr">
								{boardLabels('write', Number(params.board_id))}
							</Button>
						</Link>
					</Box>
				</Section>
			)}
			{!isLoadingList && !listError && list.items.length !== 0 && (
				<Section pt={isMobile ? 40 : 80} pb={100}>
					<PagiNationSection isMobile={isMobile}>
						<ReactPaginate
							breakLabel="..."
							previousLabel="&larr;"
							nextLabel="&rarr;"
							onPageChange={pageClick}
							pageRangeDisplayed={isMobile ? 4 : 10}
							forcePage={params.pageNum !== undefined ? Number(params.pageNum) - 1 : 0}
							pageCount={Math.ceil(Number(list.total) / limit)}
						/>
					</PagiNationSection>
				</Section>
			)}			
		</>
	);
}

BoardList.defaultProps = {};

export default BoardList;
